/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsBillingSubscribeCtrl
 */
angular.module('mercury.modules.settings.billing')
.controller('SettingsBillingSubscribeCtrl', ["Payments", "$scope", "$stateParams", "title", function(Payments, $scope, $stateParams, title) {
  title.set('Payment Details');

  $scope.loading = Payments.getTypes();
  $scope.loading.then(function(result) {
    $scope.monthlyDetails = result.data[0];
    $scope.annualDetails = result.data[1];
  });

  $scope.companyId = $stateParams.id;
}]);
